import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import MuiIconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Badge from '@mui/material/Badge';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import TextField from "@mui/material/TextField";
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";
import Modal from "../components/Modal";
import Button from "@mui/material/Button";

import { logout, selectUsuario } from "../reducers/authSlice";
import api from "../service/api";

const IconButton = styled(MuiIconButton)({
  padding: 0.5,
  marginRight: 1,
});

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    border: "1px solid #d3d4d5",
  },
}));

const Error = styled(Box)(({ theme }) => ({
  backgroundColor: "#fadddd",
  color: "#772b35",
  borderColor: "#f8cfcf",
  borderRadius: ".25rem",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  textAlign: "center",
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

const Correcto = styled(Box)(({ theme }) => ({
  backgroundColor: "#ddfae0",
  color: "#ddfae0",
  borderColor: "#ddfae0",
  borderRadius: ".25rem",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  textAlign: "center",
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

const Notificaciones = (props) => {
  const { anchorNotificaciones, handleCloseNotificaciones, notificaciones } = props;

  return (
    <Popover
      id="notificacion-menu"
      open={Boolean(anchorNotificaciones)}
      anchorEl={anchorNotificaciones}
      onClose={handleCloseNotificaciones}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          width: "350px",
          maxWidth: "100%",
        }
      }}
    >
      <List>
        <ListSubheader component="div" id="notificaciones-subheader">
          NOTIFICACIONES
        </ListSubheader>
        {notificaciones.map((notificacion, index) => (
          <ListItemButton key={index} divider>
            <ListItemText
              primary={<><Typography variant="aclaracion">{notificacion.fecha_desde}</Typography><Typography variant="body1">{notificacion.titulo}</Typography></>}
              secondary={<><Typography variant="body1">{notificacion.mensaje}</Typography></>}
            />
          </ListItemButton>
        ))}
        {notificaciones.length === 0 ? (<>
          <ListItem key="sin-datos">
            <ListItemText
              secondary={"Sin notificaciones"}
              secondaryTypographyProps={{ variant: "aclaracion" }}
            />
          </ListItem>
        </>) : ""}
      </List>
    </Popover>
  );
};

const UserMenu = (props) => {
  const dispatch = useDispatch();
  const usuario = useSelector(selectUsuario);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorNotificaciones, setAnchorNotificaciones] = useState(null);
  const [notificaciones, setNotificaciones] = useState([]);
  const [notificacionesCant, setNotificacionesCant] = useState("");
  const captcha = useRef(null);
  const [submitting, setSubmitting] = useState(false);
  const [tipoMensaje, setTipoMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [usuarioConectado, setUsuarioConectado] = useState("");

  const width = 600; // lo que mide de ancho la ventana popup
  const [width_pantalla] = useState(window.innerWidth); // lo que mide la pantalla completa
  const ajuste_horizontal = parseInt((width_pantalla - width) / 2);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleClickNotificaciones = (event) => {

    setAnchorNotificaciones(event.currentTarget);

    api
      .agregarVistoMsj()
      .then((res) => {
        console.log("Visto");
      })
      .catch((e) => {
        console.log("Error al visar");
      });

  };

  const handleCloseNotificaciones = () => {
    setAnchorNotificaciones(null);
    buscarNotificaciones();
    buscarCantNotificaciones();
  };

  const buscarNotificaciones = async () => {
    try {
      let resultado = await api.listaNotificaciones();
      setNotificaciones(resultado.data);
    } catch (e) {
      console.log(e);
    }
  };

  const buscarCantNotificaciones = async () => {
    try {
      let resultado = await api.listaCantNotificaciones();
      setNotificacionesCant(resultado.data[0].cantidad_sin_leer);
    } catch (e) {
      console.log(e);
    }
  };

  const buscarUsuarioConectado = () => {
    api
      .mostrarDatosPersonales()
      .then((res) => {
        setUsuarioConectado(res.data[0].dni);
      })

      .catch((e) => {
        console.log("Error al buscar los datos del usuario");
      });
  };


  //*************  CAMBIAR CONTRASEÑA ***********/
  const validationSchema = Yup.object().shape({
    passwordAnterior: Yup.string()
      .min(6, 'Minimo 6 dígitos')
      .max(200, 'Máximo 200 dígitos')
      .required('Requerido'),
    passwordNueva: Yup.string()
      .min(6, 'Minimo 6 dígitos')
      .max(200, 'Máximo 200 dígitos')
      .required('Requerido'),
    reingresarPasswordNueva: Yup.string()
      .min(6, 'Minimo 6 dígitos')
      .max(200, 'Máximo 200 dígitos')
      .required('Requerido')
      .oneOf([Yup.ref("passwordNueva"), null], "Las contraseñas deben coincidir"),
  });

  const formik = useFormik({
    initialValues: {
      passwordAnterior: '',
      passwordNueva: '',
      reingresarPasswordNueva: ''
    },

    enableReinitialize: true,
    validationSchema: validationSchema,

    onSubmit: (values) => {
      if (captcha.current.getValue() === "") {
        setTipoMensaje("N");
        setMensaje('Debe validar el reCAPTCHA.');
      } else {
        setTipoMensaje("");
        setMensaje("");
        setSubmitting(true);
        let datos = {
          usuario: usuarioConectado,
          contrasenia: values.passwordAnterior,
          hash_nuevo: values.passwordNueva,
          captcha: captcha.current.getValue()  
        };

        api
          .modificarPass(datos)
          .then((res) => {
            setTipoMensaje("S");
            setMensaje('La contraseña se modificó correctamente. Vuelva a ingresar al sistema con la nueva contraseña.');
            setTimeout(() => {
              cerrarCambiar();
            }, 4000);

          })
          .catch((e) => {
            setTipoMensaje("N");
            setMensaje('Error al intentar modificar la contraseña.');
            setSubmitting(false);
          });
      }
    },
    onReset: () => {
    },
  });

  const [showCambiar, setShowCambiar] = useState(false);

  const cerrarCambiar = () => {
    formik.resetForm();
    setSubmitting(false);
    setMensaje('');    
    setTipoMensaje('');
    setShowCambiar(false);
  }

  const mostrarCambiar = () => {
    setMensaje('');   
    setShowCambiar(true);
  }

  useEffect(() => {
    buscarUsuarioConectado();
  }, []);

  useEffect(() => {
    buscarNotificaciones();
    buscarCantNotificaciones();

    const interval = setInterval(() => {
      buscarNotificaciones();
      buscarCantNotificaciones();
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Typography
        component="p"
        variant="body2"
        sx={{
          fontWeight: "bold",
          color: "gray",
          mr: 1,
          display: { xs: "none", md: "block" },
        }}
        noWrap
      >
        {usuario}
      </Typography>

      {notificacionesCant === "0" ?
        <>
          <IconButton sx={{ color: "gray" }} title="Notificaciones">
            <NotificationsOutlinedIcon />
          </IconButton>
        </>
        :
        <>
          <Badge color="primary" badgeContent={notificacionesCant}>
            <IconButton sx={{ color: "gray" }} onClick={handleClickNotificaciones} title="Notificaciones">
              <NotificationsOutlinedIcon />
            </IconButton>
          </Badge>
        </>
      }

      <IconButton sx={{ color: "gray" }} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>

      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={mostrarCambiar}
        >
          <ListItemIcon>
            <CreateOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Cambiar Contraseña"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            handleLogout();
            handleClose();
          }}
        >
          <ListItemIcon>
            <ExitToAppOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Cerrar Sesión"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
      </StyledMenu>

      <Notificaciones
        anchorNotificaciones={anchorNotificaciones}
        handleCloseNotificaciones={handleCloseNotificaciones}
        notificaciones={notificaciones}
      />

      <Modal open={showCambiar} handleClose={cerrarCambiar}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} sx={{ marginBottom: 1 }}>
          </Grid>
        </Grid>

        <form
          id="formCambiar"
          name="formCambiar"
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          noValidate
          autoComplete="off"
        >
          <Grid container justifyContent="space-between" spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="titulo">
                CAMBIAR CONTRASEÑA
                </Typography>
            </Grid>
            <br></br><br></br>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="cuerpo">
                <b>Recomendamos que por seguridad la contraseña elegida sea única, es decir que no sea utilizada para conectarse a otras cuentas.</b>
              </Typography>
            </Grid>
          </Grid>
          <br></br>
          <Grid container spacing={1}>
            <Grid item lg={12} xs={12}>
              <Typography variant="titulo">
                Inscripta/o: <b>{usuario}</b>
              </Typography>
            </Grid>
            <br></br><br></br>
            <Grid item lg={12} xs={12}>
              <TextField
                id="passwordAnterior"
                name="passwordAnterior"
                label="CONTRASEÑA ANTERIOR"
                variant="outlined"
                size="small"
                type="password"
                fullWidth
                onChange={formik.handleChange}
                value={formik.values.passwordAnterior}
                error={
                  formik.touched.passwordAnterior &&
                  Boolean(formik.errors.passwordAnterior)
                }
                helperText={
                  formik.touched.passwordAnterior &&
                  formik.errors.passwordAnterior
                }
              />
            </Grid>
            <Grid item lg={12} xs={12}>
              <TextField
                id="passwordNueva"
                name="passwordNueva"
                label="CONTRASEÑA NUEVA"
                variant="outlined"
                size="small"
                type="password"
                fullWidth
                onChange={formik.handleChange}
                value={formik.values.passwordNueva}
                error={
                  formik.touched.passwordNueva &&
                  Boolean(formik.errors.passwordNueva)
                }
                helperText={
                  formik.touched.passwordNueva &&
                  formik.errors.passwordNueva
                }
              />
            </Grid>
            <Grid item lg={12} xs={12}>
              <TextField
                id="reingresarPasswordNueva"
                name="reingresarPasswordNueva"
                label="REINGRESAR CONTRASEÑA"
                variant="outlined"
                size="small"
                type="password"
                fullWidth
                onChange={formik.handleChange}
                value={formik.values.reingresarPasswordNueva}
                error={
                  formik.touched.reingresarPasswordNueva &&
                  Boolean(formik.errors.reingresarPasswordNueva)
                }
                helperText={
                  formik.touched.reingresarPasswordNueva &&
                  formik.errors.reingresarPasswordNueva
                }
              />
            </Grid>
          </Grid>
          {tipoMensaje === "" ? "" : (
            tipoMensaje === "S" ? (
              <Correcto>
                <Typography component="p" variant="cuerpo">
                  {mensaje}
                </Typography>
              </Correcto>
            ) : (
                <Error>
                  <Typography component="p" variant="cuerpo">
                    {mensaje}
                  </Typography>
                </Error>
              ))}

          <Box mt={2} mb={2}>
            <div clasname="recaptcha text-center" align="center">
              <ReCAPTCHA
                ref={captcha}
                sitekey="6LdsgSgbAAAAAPg_cxA1KmgM43Lx7Mwas19i6y2A"
              />
            </div>
          </Box>

          <Grid
            item
            align="right"
            sx={{ display: { xs: "none", md: "inline" } }}
          >
            <Box align="right">
              <Button
                variant="plata"
                onClick={cerrarCambiar}
                endIcon={<ClearIcon />}
                sx={{ m: 1 }}
              >
                {"Cancelar"}
              </Button>
              <Button
                sx={{ m: 1 }}
                variant="verde"
                color="primary"
                type="submit"
                endIcon={<DoneOutlineRounded />}
                disabled={submitting}
              >
                {submitting ? "Cambiando..." : "Cambiar Contraseña"}
              </Button>
            </Box>
          </Grid>
        </form>
      </Modal>

    </>
  );
};

export default UserMenu;